
export default {
  download: {
    'documentTitle': 'ORS útvonal',
    'download': 'Letöltés',
    'downloadFileName': 'Letöltendő fájl neve',
    'downloadFormat': 'Letöltendő fájl formátuma',
    'downloadRoute': 'Útvonal letöltése',
    'preparingDownload': 'Letöltés előkészítése…',
    'fileReady': 'Fájl kész',
    'errorPreparingFile': 'Hiba történt a fájl előkészítésekor',
    'fileTooBigToBeDownloaded': 'A fájl túl nagy a letöltéshez',
    'standard': 'Standard'
  }
}
